// @ts-nocheck
import { Box, Heading, Tabs } from "@chakra-ui/react";
import { createFileRoute } from "@tanstack/react-router";

import ExtractSchema from "@/components/Extraction/ExtractSchema";
import ExtractionResults from "@/components/Extraction/ExtractionResults";
import useAuth from "@/hooks/useAuth";

const tabsConfig = [
  { value: "doc-schema", title: "스키마", component: ExtractSchema },
  {
    value: "extraction-result",
    title: "추출 결과",
    component: ExtractionResults,
  },
];

export const Route = createFileRoute("/_layout/extraction")({
  component: Extraction,
});

function Extraction() {
  const { user: currentUser } = useAuth();

  if (!currentUser) {
    return null;
  }

  return (
    <Box
      h="100%"
      w="100%"
      display="flex"
      flexDirection="column"
      overflow="hidden"
    >
      <Box flexShrink={0}>
        <Heading size="lg" textAlign={{ base: "center", md: "left" }} py={4}>
          데이터 추출
        </Heading>
      </Box>

      <Tabs.Root
        defaultValue="doc-schema"
        variant="enclosed"
        display="flex"
        flexDirection="column"
        flex={1}
        minH={0}
      >
        <Tabs.List>
          {tabsConfig.map((tab) => (
            <Tabs.Trigger key={tab.value} value={tab.value}>
              {tab.title}
            </Tabs.Trigger>
          ))}
        </Tabs.List>
        {tabsConfig.map((tab) => (
          <Tabs.Content
            key={tab.value}
            value={tab.value}
            flex={1}
            overflow="hidden"
          >
            <tab.component />
          </Tabs.Content>
        ))}
      </Tabs.Root>
    </Box>
  );
}
